import { DateTime } from '@ksyos/date-time';
import type { IProcessActivity } from '@common/interfaces/api/processesApi';
import type { BariatricsExternalReferralData } from '@common/validation/customControls/bariatrics/bariatricsExternalReferral/v1/bariatricsExternalReferralSchema';
import type { BariPostNurseSpecialistFollowUpData } from '@common/validation/customControls/bariPost/bariPostNurseSpecialistFollowUp/types';
import type { BariPostTreatmentReportData } from '@common/validation/customControls/bariPost/bariPostTreatmentReport/v1/bariPostTreatmentReportSchemaV1';
import type { IOption } from '@frontend/components/interfaces';
import { StatusBehandeling, TypeBehandelaar } from '@common/customControls/bariatrics';
import { isDefined } from '@common/utils/isDefined';
import { isNotNull } from '@common/utils/isNotNull';

export function getRemainingDoorverwijzingenOptions(
    referralActivities: IProcessActivity<BariatricsExternalReferralData>[],
    followUpActivities: IProcessActivity<BariPostNurseSpecialistFollowUpData>[],
    treatmentReportActivities: IProcessActivity<BariPostTreatmentReportData>[]
): IOption<string>[] {
    const closedTreatmentReportRelatedActivityIds =
        getClosedTreatmentReportRelatedActivityIds(treatmentReportActivities);
    const remainingActivities = [...referralActivities, ...followUpActivities].filter(
        ({ id }) => !closedTreatmentReportRelatedActivityIds.includes(id)
    );

    return remainingActivities
        .map(({ id, customControlData }) => {
            const behandelaar = getBehandelaar(customControlData);
            const dateOfReferral = customControlData.datum_verwijzing;

            if (!behandelaar || !dateOfReferral) {
                return;
            }

            return {
                label: `Doorverwijzing ${behandelaar} ${DateTime.from(dateOfReferral).format('DD-MM-YYYY')}`,
                value: id,
            };
        })
        .filter(isDefined);
}

function getClosedTreatmentReportRelatedActivityIds(
    treatmentReportActivities: IProcessActivity<BariPostTreatmentReportData>[]
): string[] {
    return treatmentReportActivities
        .filter(({ customControlData }) => customControlData.status_behandeling === StatusBehandeling.afgerond)
        .map(({ customControlData }) => customControlData.relatedProcessActivityId)
        .filter(isNotNull);
}

function getBehandelaar(
    customControlData: BariatricsExternalReferralData | BariPostNurseSpecialistFollowUpData
): string | null {
    return customControlData.type_behandelaar === TypeBehandelaar.overig
        ? customControlData.type_behandelaar_overig
        : customControlData.type_behandelaar;
}
